module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-4"
  }, [_c('p', {
    staticClass: "TOCtitle"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('a', {
    attrs: {
      "href": "#/ChapterOne#Anchor-1"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('a', {
    attrs: {
      "href": "#/ChapterTwo#Anchor-1"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/ChapterThree#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/ChapterFour#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/ChapterFive#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/ChapterSix#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/ChapterSeven#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/ChapterEight#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/ChapterNine#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/ChapterTen#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/ChapterEleven#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/ChapterTwelve#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/ChapterThirteen#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/ChapterFourteen#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/ChapterFifteen#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/ChapterSixteen#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/Epilogue#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/Excerpt#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpt from "), _c('em', [_vm._v("Marriage Made in Shame")]), _vm._v(" by Sophia James")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 78
// module chunks = 0